import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import VerifiedIcon from 'material-ui/svg-icons/action/check-circle';
import { green700 } from 'material-ui/styles/colors';
// APP
import './StepValidation.css';
import API from './api';

class StepValidation extends Component {

    static LENGTH_VALIDATION_CODE = 4;

    state = {
        isValid: false,
        validationCode: '',
        errorText: null
    };

    onChangeValidationCode = (code) => {
        this.setState({
            isValid: false,
            validationCode: code,
            errorText: null,
        });

        // If proper code, check validation
        if (code.length >= StepValidation.LENGTH_VALIDATION_CODE) {
            API.validateConfirmationCode(this.props.createdAgendaBooking.id, code)
                .then(response => {
                    if (response.data.success) {

                        // If Existing user, we're done
                        if (this.props.formData.existingUser) {
                            this.setState({
                                isValid: true,
                                errorText: response.data.message
                            });
                        }
                        // If new user, we need to create it
                        else {
                            this._saveNewUser();
                        }
                    }
                    else {
                        this.setState({ errorText: response.data.message });
                    }
                })
                .catch(error => {
                    this.setState({ errorText: error.message });
                });
        }
    };

    /**
     * Save new user then update agenda_booking with new customer ID
     * @private
     */
    _saveNewUser() {
        if (!this.props.formData.existingUser) {
            // Save new user
            API.saveUser(this.props.formData.name, this.props.formData.phone)
                .then(response => {
                    if (response.data.success)
                        // Update existing agenda booking
                        return API.updateBooking(this.props.createdAgendaBooking.id, {id_client: response.data.data.id});
                    else
                        throw new Error(response.data.message);
                })
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            isValid: true,
                            errorText: '',
                        });
                    }
                    else {
                        throw new Error(response.data.message);
                    }
                })
                .catch(error => {
                    this.setState({ errorText: error.message });
                });
        }
    }

    getErrorStyle() {
        // Returns custom style if code is valid
        if (this.state.isValid) {
            return {
                color: green700
            };
        }

        return {};
    }

    renderValidIcon() {
        if (!this.state.isValid && this.props.validationCode) {
            return null;
        }

        let confirmation = (this.props.bookingValidation) ? 'Votre demande de rendez-vous a bien été envoyée. Il vous sera confirmé dans les plus brefs délais.' : 'Votre rendez-vous est confirmé. A bientôt !';

        return (
            <div
              className="step-validation-valid-container"
                style={{ color: this.props.muiTheme.palette.primary1Color }}
            >
                <div className="step-validation-valid-title">
                  VOTRE DEMANDE EST VALIDÉE
                </div><br />
                <VerifiedIcon
                  className="step-validation-valid-icon"
                  color={this.props.muiTheme.palette.primary1Color}
                /><br />
                <p style={{ color: this.props.muiTheme.palette.textColor }}>
                    {confirmation}
                </p>
            </div>
        );
    }

    renderInputCode() {
        if (this.state.isValid || !this.props.validationCode) {
            return null;
        }

        let method = (this.props.mailValidationCode) ? 'e-mail à l\'adresse' : 'SMS au';
        let phoneOrMail = (this.props.mailValidationCode) ? this.props.formData.email : this.props.formData.phone;

        return (
            <div>
                <h2>ENTREZ VOTRE CODE</h2>
                <p className="step-validation-subtext">
                    Nous venons de vous envoyer un {method} <br />
                    <strong>{phoneOrMail}</strong>, avec un code à rentrer ci-dessous.
                </p>
                <Paper
                    className="step-validation-code-container"
                    zDepth={1}
                >
                    <TextField
                        value={this.state.validationCode}
                        type="tel"
                        onChange={event => this.onChangeValidationCode(event.target.value)}
                        hintText="VOTRE CODE"
                        floatingLabelFocusStyle={this.getErrorStyle()}
                        errorText={this.state.errorText}
                        underlineShow={true}
                        className="step-validation-code-input"
                        errorStyle={this.getErrorStyle()}
                        hintStyle={{
                            margin: 'auto',
                            width: '100%',
                            textAlign: 'center',
                        }}
                        inputStyle={{
                            fontSize: '2em',
                            textAlign: 'center',
                        }}
                    />
                </Paper>
            </div>
        );
    }

    render() {

        return (
            <div>
                <div className="step-validation-container">
                    {this.renderInputCode()}

                    {this.renderValidIcon()}
                </div>

                <div className="step-validation-footer">
                    {!this.state.isValid &&
                        <RaisedButton
                            label='Valider mon code'
                            primary={true}
                            disabled={true}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default muiThemeable()(StepValidation);


// WEBPACK FOOTER //
// ./src/StepValidation.js